import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { BUTTON_SIZE, BUTTON_TYPE } from '@helpers/constants'

import {
    ButtonType,
    SetPadding,
    Margin,
    MarginBottom,
    ButtonSize,
    IconRight,
    Disabled,
    MarginRight,
    MarginLeft,
} from './style'
import Icon from '@components/Icon'

const Button = forwardRef((props, ref) => {
    const {
        to,
        href,
        type,
        size = BUTTON_SIZE.MEDIUM,
        children,
        icon,
        handleClick,
        margin,
        marginBottom,
        marginRight,
        marginLeft,
        iconRight,
        iconLeft,
        textColor,
        textSize,
        backgroundColor,
        disabled,
        underline,
        classes,
        active = false,
        subject,
        nativeTypeAttribute,
        iconClasses,
    } = props

    const buttonClassNames = classNames(
        ButtonType(type, active, subject),
        ButtonSize[size],
        textColor,
        textSize,
        backgroundColor,
        classes,
        'focus:outline-none',
        {
            [`${Margin}`]: margin,
            [`${MarginBottom}`]: marginBottom,
            [`${MarginRight}`]: marginRight,
            [`${MarginLeft}`]: marginLeft,
            [`${IconRight}`]: iconRight,
            [`${Disabled}`]: disabled,
        }
    )

    const spanClassNames = classNames('font-secondary', {
        [`${SetPadding.right}`]: iconRight,
        [`${SetPadding.left}`]: iconLeft,
        underline,
    })

    const getContent = () => (
        <>
            {icon && <span><Icon iconClasses={iconClasses} icon={icon} /></span>}
            {children && <span className={spanClassNames}>{children}</span>}
        </>
    )

    if(href){
      return (
        <a
            className={buttonClassNames}
            href={href}
            onClick={handleClick}
            textcolor={textColor}
            ref={ref}
        >
            {getContent()}
        </a>
      )
    }

    return to ? (
        <Link
            className={buttonClassNames}
            to={to}
            onClick={handleClick}
            textcolor={textColor}
            ref={ref}
        >
            {getContent()}
        </Link>
    ) : (
        <button
            className={buttonClassNames}
            onClick={handleClick}
            disabled={disabled}
            textcolor={textColor}
            value
            type={nativeTypeAttribute}
            ref={ref}
        >
            {getContent()}
        </button>
    )
})

Button.propTypes = {
    to: PropTypes.string,
    href: PropTypes.string,
    type: PropTypes.oneOf(Object.values(BUTTON_TYPE)),
    size: PropTypes.oneOf(Object.values(BUTTON_SIZE)),
    subject: PropTypes.string,
    children: PropTypes.any,
    icon: PropTypes.string,
    handleClick: PropTypes.func,
    margin: PropTypes.bool,
    marginBottom: PropTypes.bool,
    iconRight: PropTypes.bool,
    iconLeft: PropTypes.bool,
    textColor: PropTypes.string,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string,
    disabled: PropTypes.bool,
    underline: PropTypes.bool,
    nativeTypeAttribute: PropTypes.string,
    classes: PropTypes.string,
    iconClasses: PropTypes.string,
}

export default Button
